/**
 * Revelation des sections au defilement.
 *
 * Un IntersectionObserver plutot qu'un ecouteur de scroll : le navigateur
 * fait le calcul hors du fil principal, et on ne declenche rien a chaque
 * pixel parcouru.
 */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var REVEAL_TARGETS = [
    'main > .shopify-section + .shopify-section',
    '[data-reveal]',
  ].join(', ');

  var isSmall = window.matchMedia('(max-width: 749px)').matches;
  // ms entre deux enfants d'un meme groupe. Sur mobile la cascade est
  // supprimee : elle laisse des blocs vides derriere le doigt.
  var STAGGER_STEP = isSmall ? 0 : 40;
  var STAGGER_MAX = 3;

  function revealAll() {
    document.querySelectorAll(REVEAL_TARGETS).forEach(function (el) {
      el.classList.add('is-revealed');
    });
  }

  // Sans IntersectionObserver, on montre tout plutot que de risquer
  // une page vide.
  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        // Une section ne se revele qu'une fois : re-animer au retour
        // serait du mouvement decoratif et distrayant.
        observer.unobserve(entry.target);
      });
    },
    {
      // Marge basse positive : l'element se revele avant d'entrer dans
      // l'ecran, donc il est deja en place quand l'oeil l'atteint, meme
      // en defilement rapide sur mobile.
      rootMargin: isSmall ? '0px 0px 45% 0px' : '0px 0px 20% 0px',
      threshold: 0,
    }
  );

  function observe(root) {
    (root || document).querySelectorAll(REVEAL_TARGETS).forEach(function (el) {
      if (el.dataset.revealBound) return;
      el.dataset.revealBound = '1';
      observer.observe(el);
    });
  }

  function applyStagger(root) {
    if (!STAGGER_STEP) return;
    (root || document).querySelectorAll('[data-reveal-group]').forEach(function (group) {
      var children = group.querySelectorAll(':scope > [data-reveal]');
      children.forEach(function (child, i) {
        // Au-dela de quelques elements, la cascade se fait attendre :
        // on plafonne le retard.
        var step = Math.min(i, STAGGER_MAX) * STAGGER_STEP;
        child.style.setProperty('--reveal-delay', step + 'ms');
      });
    });
  }

  function init(root) {
    applyStagger(root);
    observe(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Filet de securite : si un bloc n'a pas ete revele (defilement tres
  // rapide, onglet en arriere-plan, observer en retard), on le montre.
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll(REVEAL_TARGETS).forEach(function (el) {
        if (el.classList.contains('is-revealed')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.5) {
          el.classList.add('is-revealed');
        }
      });
    }, 400);
  });

  // L'editeur de theme recharge une section sans recharger la page :
  // sans ceci, la section rechargee resterait invisible.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
